<template>
	<nk-dropdown v-model="dropdownValue" :data="dropdownData" :options="settings.dropdownOptions" ref="input" :tabindex="tabindex" :disabled="disabled ? true : null"></nk-dropdown>
</template>
<script>
	import _ from 'lodash'
	import { mapActions, mapGetters } from 'vuex'
	import $sc from '~/plugins/shortcut.collection.js'
	import measureUnits from '~/views/sale/products/measureunit-list.vue'

	export default {
		props: {
			modelValue: {},
			options: {},
			tabindex: {},
			data: { type: Array },
			disabled: { type: Boolean, default: false }
		},
		emits: ['update:modelValue'],
		data() {
			return {
				settings: {
					type: null,
					dropdownOptions: {
						rowIdentifier: 'id',
						remoteSearch: false,
						placeholder: this.$t('select-it'),
						searchableFields: ['name'],
						findExactMatch: this.findExactMatch,
						selectorWidth: 'auto',
						buttons: [{
							title: this.$t('manage-items'),
							shortcut: $sc.find('enter'),
							isPrimary: true,
							element: () => { return this.$el },
							icon: 'list-ul',
							handle: (button, page, e) => {
								this.showProductMeasureUnits()
							}
						}]
					}
				},
				localValue: null
			}
		},
		computed: {
			...mapGetters({
				all: 'productMeasureUnits/all'
			}),
			dropdownValue: {
				get() {
					return this.localValue
				},
				set(val) {
					this.$emit('update:modelValue', val)

					if (this.settings.dropdownOptions.onChangeHandler && typeof this.settings.dropdownOptions.onChangeHandler == 'function' && val)
						this.settings.dropdownOptions.onChangeHandler(val)

					this.localValue = val
				}
			},
			dropdownData() {
				return (this.data || []).length ? this.data : this.all
			}
		},
		watch: {
			modelValue: {
				handler(val, oldVal) {
					this.localValue = val
				}
			},
			options: {
				immediate: true,
				deep: true,
				handler(val) {
					this.settings = _.merge(this.settings, val)
					this.settings.dropdownOptions.buttons[0].visible = !this.settings.hideManageMeasureUnits
				}
			}
		},
		created() {
			this.localValue = this.modelValue
		},
		mounted() {
			this.refreshProductMeasureUnits()
		},
		methods: {
			...mapActions({
				refreshProductMeasureUnits: 'productMeasureUnits/refresh'
			}),
			showProductMeasureUnits() {
				this.showModal({ component: measureUnits, data: this.dropdownValue, options: { type: this.settings.type, selectable: true } })
					.then(result => {
						this.dropdownValue = result
						this.$refs.input.focusAndSelect()
					}).catch(() => { })
			}
		},
	}
</script>
<style></style>
